import { Wrench, Settings, GraduationCap, ShieldCheck, ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { SloganQuote } from "@/components/SloganQuote";

const services = [
  { icon: Settings, title: "Instalare & punere în funcțiune", text: "Montaj profesional al utilajelor la sediul tău, calibrare și testare completă înainte de predare." },
  { icon: Wrench, title: "Service & mentenanță", text: "Contracte de mentenanță preventivă și intervenții rapide pentru minimizarea timpilor de oprire." },
  { icon: GraduationCap, title: "Instruire operatori", text: "Training tehnic pentru echipa ta privind utilizarea sigură și eficientă a echipamentelor." },
  { icon: ShieldCheck, title: "Garanție & piese originale", text: "Furnizăm piese de schimb originale și suport tehnic pe toată durata de viață a utilajului." },
];

const steps = ["Evaluare nevoi & ofertă", "Livrare specializată", "Instalare & calibrare", "Instruire & predare"];

export default function Services() {
  return (
    <div>
      <section className="relative bg-slate-900 text-white">
        <img src="https://images.pexels.com/photos/3688760/pexels-photo-3688760.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1600"
          alt="Echipă instalare" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative max-w-7xl mx-auto px-6 py-24">
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-orange-500">Servicii</span>
          <h1 className="text-4xl lg:text-5xl font-black tracking-tighter mt-4 max-w-2xl">Instalare și service complet pentru utilajele tale</h1>
          <p className="text-slate-300 mt-5 max-w-xl text-lg">De la livrare până la punerea în funcțiune și instruirea operatorilor — ne ocupăm de tot.</p>
          <SloganQuote sloganKey="slogan_workplace" dark testid="services-slogan" className="mt-8 max-w-2xl text-base sm:text-lg" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s, i) => (
            <div key={s.title} className="border border-slate-200 p-8 hover:border-slate-400 transition-colors" data-testid={`service-${i}`}>
              <s.icon className="w-9 h-9 text-orange-600" />
              <h3 className="text-xl font-bold text-slate-900 mt-4">{s.title}</h3>
              <p className="text-slate-500 mt-3 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-slate-50 border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Proces</span>
          <h2 className="text-3xl lg:text-4xl font-black tracking-tight mt-2 mb-12">Cum lucrăm</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {steps.map((s, i) => (
              <div key={s} className="bg-white border border-slate-200 p-6">
                <div className="text-4xl font-black text-orange-600/20">{String(i + 1).padStart(2, "0")}</div>
                <div className="flex items-center gap-2 mt-3 font-bold text-slate-900"><CheckCircle2 className="w-4 h-4 text-orange-600" /> {s}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20 text-center">
        <h2 className="text-3xl font-black tracking-tight">Solicită o ofertă pentru servicii</h2>
        <Link to="/contact" className="inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 font-bold uppercase tracking-wide text-sm mt-6 transition-colors" data-testid="services-cta">
          Contactează-ne <ArrowRight className="w-4 h-4" />
        </Link>
      </section>
    </div>
  );
}
